import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { MoneyPipe } from '@shared/pipes/money.pipe';

import { InvestigatorForecastOverviewAmountComponent } from './overview-amount/overview-amount.component';
import { InvestigatorForecastOverviewAveragesComponent } from './overview-averages/overview-averages.component';
import { InvestigatorForecastOverviewPatientVisitsComponent } from './overview-patient-visits/overview-patient-visits.component';
import {
  InvestigatorForecastForm,
  InvestigatorForecastTotals,
  InvestigatorForecastValues,
  SourceType,
} from '../../../types/investigator-forecast.types';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    InvestigatorForecastOverviewAmountComponent,
    NgClass,
    InvestigatorForecastOverviewAveragesComponent,
    InvestigatorForecastOverviewPatientVisitsComponent,
    MoneyPipe,
  ],
  selector: 'aux-investigator-forecast-overview',
  templateUrl: './investigator-overview.component.html',
})
export class InvestigatorForecastOverviewComponent {
  @Input() form!: FormGroup<InvestigatorForecastForm>;
  @Input() formValues!: InvestigatorForecastValues;
  sourceTypes = SourceType;

  getBottomTotalValuesBySelectedSource(): InvestigatorForecastTotals | null {
    const { source } = this.formValues;

    if (!source || source === SourceType.Contracted || source === SourceType.PatientVisits) {
      return null;
    }

    const formValues = this.formValues[source as SourceType];

    return {
      remainingAmount: formValues.remainingAmount,
      spendToDateAmount: formValues.spendToDateAmount,
      totalInvestigatorCosts: formValues.totalInvestigatorCosts,
    };
  }
}
